// Central i18n configuration.
// Danish is the default and lives at the site root (no prefix); English and
// German are prefixed with /en and /de. Slugs are translated per language —
// see slugMap.ts for the canonical path table.

export const locales = ["da", "en", "de"] as const;
export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "da";

/** URL prefix per locale. Danish is rootless. */
export const localePrefix: Record<Locale, string> = {
  da: "",
  en: "/en",
  de: "/de",
};

/** Value for the <html lang> attribute. */
export const htmlLang: Record<Locale, string> = {
  da: "da",
  en: "en",
  de: "de",
};

/** og:locale value per locale. */
export const ogLocale: Record<Locale, string> = {
  da: "da_DK",
  en: "en_US",
  de: "de_DE",
};

/** Human-readable label for the language switcher. */
export const localeLabel: Record<Locale, string> = {
  da: "DA",
  en: "EN",
  de: "DE",
};

/**
 * Derive the active locale purely from the URL pathname. Pure and
 * deterministic so it produces identical results on the server and the client
 * (no hydration mismatch). Used by the root shell and the LocaleProvider.
 */
export function localeFromPathname(pathname: string): Locale {
  if (pathname === "/en" || pathname.startsWith("/en/")) return "en";
  if (pathname === "/de" || pathname.startsWith("/de/")) return "de";
  return "da";
}
